<div class="color-{{ iconColor }} {{ className }}" dropdown container="body" [placement]="placement">
  <div
    *ngIf="isCustomButton; else defaultDropdownToggle"
    aria-hidden="true"
    [attr.aria-controls]="id"
    [id]="id"
    class="d-flex justify-content-center"
    dropdownToggle
  >
    <ng-content select="[custom-dropdown-button]"></ng-content>
  </div>
  <ng-template #defaultDropdownToggle>
    <i class="dropdown-toggle fa fa-ellipsis-h" aria-hidden="true" [attr.aria-controls]="id" [id]="id" dropdownToggle></i>
  </ng-template>
  <div
    *dropdownMenu
    class="dropdown-menu dropdown-menu-right custom"
    [id]="id"
    [attr.aria-labelledby]="id"
    [ngClass]="{
      'custom-light': menuMode === enumDropdownActionMenuMode.LIGHT,
      'custom-default': menuMode === enumDropdownActionMenuMode.DEFAULT,
      'custom-blue': menuMode === enumDropdownActionMenuMode.BLUE
    }"
  >
    <ng-content select="[dropdown-item]"></ng-content>
  </div>
</div>
